import { Panel, Search, Table, Column, Tabs, Tab } from "@appkit4/react-components";
import { ActiveFilters } from "components/layout/filters/filters";
import { FC, useState, useEffect, useMemo } from "react";
import { Profile, ListType } from "routes/analysis/types/analysis";
import UsersInline from "routes/analysis/users/usersInline";
import { searchFilter } from "services/common";

const ProfileDetails: FC<{ profile: Profile }> = ({ profile }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [search, setSearch] = useState("");
  const handleTabChange = (index: number) => {
    setActiveIndex(index);
  }
  useEffect(() => {
    let element = document.getElementById(profile.name);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        inline: "nearest"
      });
    }
  }, [profile.name]);
  const filteredProfiles = useMemo(
    () => profile.profiles?.filter(f => searchFilter(f, ["name"], search)) || [],
    [profile.profiles, search]
  );

  const getUsersInlineType = (profile: Profile) =>
    (profile.isComposite || profile.compositeProfileId) ? ListType.CompositeProfile : ListType.Profile;

  return (
    <div className="ap-accordion-open">
      <div className="tabs-wrapper">
        <Tabs activeIndex={activeIndex} onTabChange={handleTabChange}>
          <Tab label="Users"></Tab>
          <Tab label="Profiles" disabled={!profile.isComposite}></Tab>
        </Tabs>
      </div>
      {activeIndex === 1 ? (
        <Panel>
          <div className="flex items-center gap-4 mt-4">
            <div>
              <Search
                searchType={"secondary"}
                value={search}
                onChange={(value: string) => {
                  setSearch(value);
                }}
                className="list-filter"
              />
            </div>
          </div>
          <ActiveFilters rows={filteredProfiles.length} />
          <Table
            hasTitle
            condensed
            striped
            originalData={filteredProfiles}
          >
            <Column field="name" sortKey="name" >Profile name</Column>
            <Column field="hasMatches" sortKey="hasMatches" renderCell={(row: Profile, field: string) => {
              return row.hasMatches ? <span className="Appkit4-icon icon-alert-fill access-risk"></span> : null;
            }}>One or more matches</Column>
          </Table>
        </Panel>
      ) : activeIndex === 0 ? (
        <UsersInline 
          type={getUsersInlineType(profile)}
          typeId={profile.compositeProfileId || profile.profileId} 
        />
      ) : null}
    </div>
  );
}
export default ProfileDetails;
